import * as Yup from "yup";
import { IMessageFormik } from "./types";

type Context = Yup.TestContext<IMessageFormik>;

const atLeastOneField = (_, context: Context) => {
  const { message, file } = context.parent as IMessageFormik;
  return Boolean(message?.trim()) || Boolean(file);
};

export const MESSAGE_VALIDATION_SCHEMA = Yup.object().shape({
  message: Yup.string().test("atLeastOneField", atLeastOneField),
  file: Yup.mixed<File>().test("atLeastOneField", atLeastOneField),
});
